var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 5.83301H11.6666C6.66665 5.83301 3.33331 8.33301 3.33331 14.1663V25.833C3.33331 31.6663 6.66665 34.1663 11.6666 34.1663H28.3333C33.3333 34.1663 36.6666 31.6663 36.6666 25.833V14.1663C36.6666 8.33301 33.3333 5.83301 28.3333 5.83301ZM29.1166 15.983L23.9 20.1497C22.8 21.033 21.4 21.4663 20 21.4663C18.6 21.4663 17.1833 21.033 16.1 20.1497L10.8833 15.983C10.35 15.5497 10.2666 14.7497 10.6833 14.2163C11.1166 13.683 11.9 13.583 12.4333 14.0163L17.65 18.183C18.9166 19.1997 21.0666 19.1997 22.3333 18.183L27.55 14.0163C28.0833 13.583 28.8833 13.6663 29.3 14.2163C29.7333 14.7497 29.65 15.5497 29.1166 15.983Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9db3bea86a727cb93cb36ecb6e9c9d78.svg";
export { ForwardRef as ReactComponent };